<template>
    <div>
        <div class="footer">
            <div class="footer_left">
                <div class="callMe">联系我们</div>
                <div class="sortLine"></div>
                <div class="longLine"></div>
                <div class="left_bottom">
                    <div class="code">
                        <div class="code1">
                            <img :src="img_api + contactData.qrCode" alt="">
                            <div class="code_title">公众号</div>
                        </div>
                        <div class="code2">
                            <img :src="img_api + contactData.video" alt="">
                            <div class="code_title">视频号</div>
                        </div>
                    </div>
                    <ul class="footer_left_data">
                        <li><img src="../assets/img/16x16_chuanzhen@2x.png" alt="">&nbsp;传真：{{contactData.fax}}</li>
                        <li><img src="../assets/img/16x16_email@2x.png" alt="">&nbsp;邮箱：{{contactData.email}}</li>
                        <li><img src="../assets/img/16x16_address@2x.png" alt="">&nbsp;地址：{{contactData.address}}</li>
                        <li><img src="../assets/img/16x16_service@2x.png" alt="">&nbsp;服务保障基地：{{contactData.serviceBase}}</li>
                    </ul>
                </div>

            </div>
            <div>
                <div class="callMe">友情链接</div>
                <div class="sortLine"></div>
                <div class="longLine"></div>
                <div class="friendUrl">
                    <a :href=item.url v-for="item in friends" :key="item.id">>{{ item.name }}</a>
                </div>
            </div>
        </div>
        <div class="footer_bottom">
            ©2023-2024 版权所有 ICP证：<a class="a" style="color:#FFF" href="https://beian.miit.gov.cn/#/Integrated/index">粤1CP备20059343号</a>
</div>
    </div>
</template>

<script>
import {
    getFriends,
    getContactUs
} from "@/server/https.js";
export default {
    name: 'Footer',
    data() {
        return {
            friends: [],
            contactData:{},
            img_api: 'https://www.gdyuanwo.com/gdyuanwo/',

        }
    },
    mounted() {
        getFriends().then(res => {
            res.data.body.list.sort((a, b) => a.sort - b.sort);
            this.friends = res.data.body.list
        })
        getContactUs().then(res => {
            this.contactData = res.data.body.contactUs;
        })
    },
};
</script>

<style scoped>
.footer {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 21rem;
    width: 100%;
    background-color: #F5F7FB;
}

.footer_left {
    width: 667px;
}

.sortLine {
    float: left;
    width: 24px;
    height: 3px;
    background-color: #13489D;
    margin-top: 25px;
    z-index: 2222;
}

.longLine {
    float: left;
    margin-top: 26px;
    width: 181px;
    height: 2px;
    background-color: rgba(19, 72, 157, 0.5);
}

.callMe {
    font-weight: bold;
    color: #13489D;
    font-size: 26px;
}

.code {
    display: flex;
    margin-top: 50px;
}

.code1 {
    /* float: left; */
    width: 150px;
    height: 150px;
    margin-right: 24px;
}

.code1 img {
    width: 100%;
    height: 100%;
}

.code2 {
    /* float: left; */
    width: 150px;
    height: 150px;
}

.code2 img {
    width: 100%;
    height: 100%;
}

.code_title {
    margin-top: 12px;
    text-align: center;
    font-size: 16px;
    color: #333333;

    font-weight: 400;
}

.footer_left_data {
    /* float: left; */
    margin-top: 40px;
    margin-left: 24px;
}

.footer_left_data li {
    display: flex;
    margin-bottom: 31px;
    width: 331px;
    height:20px;
    font-size: 16px;
    color: #333333;
}
.footer_left_data li img{
    /* width: 100%; */
    height: 100% ;
}
.friendUrl {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin-top: 67px;
    height: 126px;
}

.friendUrl a {
    margin-bottom: 10px;
    font-size: 16px;
    color: #333333;
}

.footer_bottom {
    width: 100%;
    height: 44px;
    line-height: 44px;
    text-align: center;
    font-size: 14px;
    color: #fff;
    background-color: #13489D;
}

.left_bottom {
    width: 800px;
    display: flex;
}
.a:hover{
    text-decoration: underline;
}
</style>
